import React from 'react';

import * as messages from '@radnuc/messages';

import TimeAgo from '@radnuc/react-ui-components/dist/TimeAgo'
import MetricsDisplay from '@radnuc/react-ui-components/dist/MetricsDisplay'
import IsotopeDisplay from '@radnuc/react-ui-components/dist/IsotopeDisplay'
//import {IsotopeDisplay,TimeAgo} from '@radnuc/ui-components'
import BD21ShareButtonDisplay from './BD21ShareButtonDisplay'
import {SnoozeIsotopeButtonDisplay} from '@radnuc/react-ui-components/dist/SnoozeIsotopeDisplay'
//import AudioAlertDisplay from '@radnuc/react-ui-components/dist/AudioAlert'
import { LaneDisplayInterface } from '@radnuc/react-ui-components/dist/PrimaryDisplay'
import ChemBioThreatDisplay from '@radnuc/react-ui-components/dist/ChemBioThreatDisplay'
import {AuthenticationInterface} from '@radnuc/react-ui-components/dist/AuthenticationDisplay'
//import {Config} from './Config'
import { uuidToString } from '@radnuc/react-ui-components/dist/UUID';

import '@radnuc/react-ui-components/dist/InvestigationDisplay.css'

import recycle_logo from '@radnuc/react-ui-components/dist/img/Recycle_bin_-32.png'
import undo_logo from '@radnuc/react-ui-components/dist/img/undo-32.png'
import replay_logo from '@radnuc/react-ui-components/dist/img/eye-24-32.png'
import replay_white_logo from '@radnuc/react-ui-components/dist/img/eye-24-32-white.png'
import chem_alert_logo from '@radnuc/react-ui-components/dist/img/icon-chem-green.png'
import bio_alert_logo from '@radnuc/react-ui-components/dist/img/icon-biohazard-darkorange.png'
import rad_alert_logo from '@radnuc/react-ui-components/dist/img/icon-radiation-white.png'
import alert_logo from '@radnuc/react-ui-components/dist/img/icon-attention.png'
import network_alert_logo from './img/icon-network-blue.png'
import open_in_new_logo from './img/4964026_add_in_new_open_plus_icon_32.png';
import { BD21DataStream } from '../BD21DataStream';
import { MultiNodeAudioAlertDisplay } from './MultiNodeAudioAlert';
import { CloudUiDisplayInterface } from './CloudUiDisplay';
import NodeHealth, { HasCloudUI, IsAllowReplay } from '../NodeHealth';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;
type PCSResult = messages.Rad.PCSResult;
type NeutronResult = messages.Rad.NeutronResult;

export type InvTypeToShow = messages.Encounter.EncounterType[];

const API_ROOT = window.app && window.app.env.API_URL;

export interface InvestigationInterface {
    select: (inv: Investigation) => void,
    unselect: () => void,
    dismiss: (inv: Investigation) => void,
    dismissAll?: () => void,
    finalize:(inv: Investigation) => void,
    replay: (inv: Investigation) => void,
    unreplay: () => void,
    acknowledge: (inv: Investigation) => void,
    setAlertAcknowledge:(flag:boolean) => void,
    setCollapse: (inv: Investigation, flag:boolean) => void,
    setInvTypeToShow?:(type:InvTypeToShow|null) => void,
    queryDatastream?: BD21DataStream
}

interface InvestigationCardProps {
    investigation: Investigation,
    selected: boolean,
    replaying: boolean,
    investigationsNotAcknowledged?: Investigation[],
    investigationsCollapsed?: Investigation[],
    investigationInterface: InvestigationInterface,
    displayAsLanes?: boolean,
    isPrimary?: boolean,
    laneDisplayInterface?: LaneDisplayInterface,
    showSourceLocationAsDirection?: boolean,
    useSourceHeadingAndSourceLanePositionForDirection?: boolean,
    showNodeLocationInsteadofSourceLocation?: boolean,
    showSnoozeIsotopeButton?: boolean,
    authenticationInterface?: AuthenticationInterface,
    cloudUiDisplayInterface?: CloudUiDisplayInterface,
}

export interface InvestigationCardState {
    dismissed: boolean;
    collapsed: boolean;
    acknowledged: boolean;
    dismiss_dialog_show: boolean;
    share_success_state: number;
}

export class InvestigationCard extends React.Component<InvestigationCardProps, InvestigationCardState, {}> {
    card_element: React.RefObject<HTMLDivElement>;
    card_scroll_to_element: React.RefObject<HTMLDivElement>;
    timeoutTimer: NodeJS.Timeout | null;
    timer: number | null = null;

    constructor(props: InvestigationCardProps) {
        super(props)
        this.state = {
            dismissed: false,
            collapsed: false,
            acknowledged: true,
            dismiss_dialog_show: false,
            share_success_state: 0
        }

        this.card_element = React.createRef<HTMLDivElement>();
        this.card_scroll_to_element = React.createRef<HTMLDivElement>();

        this.timeoutTimer = null;
    }

    handleExpandCollapseClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.props.investigationInterface.setCollapse(this.props.investigation,!this.state.collapsed)
        this.setState(state => ({
            collapsed: !state.collapsed
        }));
    }

    handleSelectClick(event: React.MouseEvent<HTMLElement>) {
        if (this.props.selected) {
            this.props.investigationInterface.unselect();
        } else {
            this.props.investigationInterface.select(this.props.investigation);
        }
    }

    componentWillUnmount() {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        if (this.timer !== null)
            window.clearInterval(this.timer);

    }

    componentDidMount() {
        this.updateCollapsed();
        this.timer = window.setInterval(() => this.checkFinalized(), 10000);
    }

    componentDidUpdate(prevProps: InvestigationCardProps) {
        if (this.props.selected && !prevProps.selected)
            this.scrollToThisCard();
        if(this.props.investigationsNotAcknowledged !== undefined){
            if(this.props.investigationsNotAcknowledged !== prevProps.investigationsNotAcknowledged)
                this.updateAcknowledged();
        }
        if(this.props.investigationsCollapsed !== undefined){
            if(this.props.investigationsCollapsed !== prevProps.investigationsCollapsed){
                this.updateCollapsed();
            }
        }
        this.checkFinalized();


    }

    updateAcknowledged(){
        var acknowledged = true;
        if(this.props.investigationsNotAcknowledged !== undefined){
            if(this.props.investigationsNotAcknowledged.length > 0){
                this.props.investigationsNotAcknowledged.forEach((inv=>{
                    if(uuidToString(inv.id) === uuidToString(this.props.investigation.id)){
                        acknowledged = false;
                    }
                }))
            }
        }
        this.setState(state => ({
            acknowledged: acknowledged
        }));
    }

    updateCollapsed(){
        var collapsed = false;
        if(this.props.investigationsCollapsed !== undefined){
            if(this.props.investigationsCollapsed.length > 0){
                this.props.investigationsCollapsed.forEach((inv=>{
                    if(uuidToString(inv.id) === uuidToString(this.props.investigation.id)){
                        collapsed = true;
                    }
                }))
            }
        }
        this.setState(state => ({
            collapsed: collapsed
        }));
    }

    checkFinalized(){
        //console.log('updateFinalized called. THis card finalized: '+this.props.investigation.finalized)
        if(!this.props.investigation.finalized){
            if((new Date().getTime() - this.props.investigation.end_time) > 60000){ //360000){
                //console.log('finalizing this card via updateFinalized')
                this.props.investigationInterface.finalize(this.props.investigation);
                this.redraw();
            }
        }
    }

    redraw(){
        //This triggers a redraw of the card
        this.setState(state => ({
            collapsed: state.collapsed
        }));
    }

    scrollToThisCard() {
        if (this.card_scroll_to_element.current != null) {
            this.card_scroll_to_element.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    handleReplayClick() {
        if (this.props.replaying) {
            this.props.investigationInterface.unreplay();
        } else {
            this.props.investigationInterface.replay(this.props.investigation);
        }
    }

    handleDismissClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            dismiss_dialog_show: !state.dismiss_dialog_show
        }));

        if (!this.state.dismiss_dialog_show) {
            if (this.timeoutTimer != null)
                clearTimeout(this.timeoutTimer);
            this.timeoutTimer = setTimeout(state => {
                this.setState(state => ({
                    dismiss_dialog_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);
        }
    }

    handleDismissConfirmClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();

        this.setState(() => ({
            dismissed: true
        }));
        setTimeout(() => {
            this.shrinkCardAnimation();
        }, 500);
        setTimeout(() => {
            this.props.investigationInterface.dismiss(this.props.investigation);
        }, 1000);
    }

    handleDismissCancelClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(() => ({
            dismiss_dialog_show: false
        }));
    }

    shrinkCardAnimation() {
        // Shrink height animation
        var element = this.card_element.current;
        if (element != null) {
            var sectionHeight = element.scrollHeight;
            // temporarily disable all css transitions
            var elementTransition = element.style.transition;
            element.style.transition = '';

            requestAnimationFrame(() => {
                if (element != null) {
                    element.style.height = sectionHeight + 'px';
                    element.style.transition = elementTransition;
                }
                requestAnimationFrame(() => {
                    if (element != null) {
                        element.style.height = 0 + 'px';
                    }
                });
            });
        }
    }

    renderRadElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        if(expanded){
            //Max Gamma and Dose Rate
            var gamma_rate = "N/A";
            if (this.props.investigation.max_count_rate !== null) {
                gamma_rate = this.props.investigation.max_count_rate.toFixed(1)
            }
            var dose_rate = "N/A";
            if (this.props.investigation.max_count_rate !== null) {
                dose_rate = this.props.investigation.max_dose_rate.toFixed(1)
            }
            const inv_rates =
                <div className="investigation-row">
                    <MetricsDisplay title={'Peak Gamma Rate'} value={gamma_rate} units={'cps'} style={undefined} />
                    <MetricsDisplay title={'Peak Dose Rate'} value={dose_rate} units={'\u00B5R/hr'} style={undefined} />
                </div>

            var inv_isotopes =
                <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={false} hideConfidence={this.props.displayAsLanes}/>

            return (
                <>
                    {inv_rates}
                    {inv_isotopes}
                </>
            )
        } else {
            //collapsed
            let node_name = "N/A";
            if((this.props.investigation as messages.Encounter.Encounter).node_name !== undefined &&
               (this.props.investigation as messages.Encounter.Encounter).node_name !== null){
                node_name = (this.props.investigation as messages.Encounter.Encounter).node_name;
                node_name = NodeHealth.remapDeviceName(node_name)
                node_name = this.renameDeviceName(node_name)
                node_name= node_name.replace(/_/g," ");
            }
            return (
                <>
                <br></br>
                {node_name}
                <br></br>
                <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={true} hideConfidence={this.props.displayAsLanes}/>
                </>
            )
        }

    }

    findMaxChemicalThreat(){
        let max_chem_name = "N/A"
        var max_concentration = "N/A";
        if('type' in this.props.investigation){
            //console.log(this.props.investigation.chemicals)
            if (this.props.investigation.chemicals !== null) {
                var max_conc = -1000000;
                var max_chemical = -1;
                const identifications = this.props.investigation.chemicals.identifications
                identifications.forEach((thisId:messages.SigmaPlusChem.ChemicalTargetIdentification) => {
                    //if(thisId.concentration !== null){
                        //if(thisId.concentration > max_conc){
                            max_conc = thisId.concentration;
                            max_chemical = thisId.chemical
                            if(max_chemical !== messages.SigmaPlusChem.SigmaPlusChemicalTarget.BY_CAS_REGISTRY_NUMBER){
                                max_chem_name = messages.SigmaPlusChem.SigmaPlusChemicalTarget[max_chemical];
                            } else {
                                max_chem_name = thisId.cas_registry_number;
                            }
                        //}
                    //}
                });
                if(max_conc > 0){
                    max_concentration = max_conc.toFixed(3)
                }
                /*
                if(max_chemical >=0){
                    max_chem_name = messages.SigmaPlusChem.SigmaPlusChemicalTarget[max_chemical];
                }
                */
            }
        }
        return ({max_concentration:max_concentration , max_chem_name: max_chem_name});
    }

    renderChemElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        const result = this.findMaxChemicalThreat();
        //const result = {max_concentration:'1.0000' , max_chem_name: messages.SigmaPlusChem.SigmaPlusChemicalTarget[13]}
        if(expanded){
            return(
                <>
                    <div className="investigation-row">
                        <MetricsDisplay title={'Concentration'} value={result.max_concentration} units={'ppb'} style={{width:'100%'}} />
                    </div>
                    <div className="investigation-row">
                        <ChemBioThreatDisplay title={'Chemicals'} value={result.max_chem_name} units={''} style={{width:'100%'}}
                            threatStyle={{color:'white', wordWrap:'break-word',fontSize:'0.9em'}}/>
                    </div>
                </>
            )
        } else {
            //collapsed
            return (
                <div style={{color:'white',wordWrap:'break-word',fontSize:'0.9em'}}>
                    {result.max_chem_name}
                </div>
            )
        }
    }

    renderBioElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        const result = {max_concentration:'N/A' , max_bio_name: 'N/A'}
        if(expanded){
            return(
                <>
                    <div className="investigation-row">
                        <MetricsDisplay title={'Concentration'} value={result.max_concentration} units={'ppla'} style={{width:'100%'}} />
                    </div>
                    <div className="investigation-row">
                        <ChemBioThreatDisplay title={'Biologicals'} value={result.max_bio_name} units={''} style={{width:'100%'}}
                            threatStyle={{color:'darkorange', wordWrap:'break-word',fontSize:'0.9em'}}/>
                    </div>
                </>
            )
        } else {
            //collapsed
            return (
                <div style={{color:'darkorange',wordWrap:'break-word',fontSize:'0.9em'}}>
                    {result.max_bio_name}
                </div>
            )
        }
    }
    renderNodeElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        let alarming_sensor_string:string = "";
        let alarming_sensor_title:string = "Alarming Sensor";
        const alarming_sensors = (this.props.investigation as messages.Encounter.Encounter).alarming_sensors;
        if (alarming_sensors !== null && alarming_sensors.length > 0){
            alarming_sensors.forEach(sensor => {
                const make_model_string = sensor.make+' '+sensor.model;
                if(alarming_sensor_string.length > 0){
                    alarming_sensor_string += '\r\n'; //New line
                    alarming_sensor_title += 's'; //plural
                }
                alarming_sensor_string += make_model_string


            });
        } else {
            alarming_sensor_string = "N/A"
        }
        const result = {alarming_sensors:alarming_sensor_string , max_bio_name: 'BIO'}
        if(expanded){
            return(
                <>
                    <div className="investigation-row">
                        <MetricsDisplay title={alarming_sensor_title} value={result.alarming_sensors} units={''} style={{width:'100%',whiteSpace:'pre-wrap'}} />
                    </div>
                    <div className="investigation-row">
                        <ChemBioThreatDisplay title={'Biologicals'} value={result.max_bio_name} units={''} style={{width:'100%'}}
                            threatStyle={{color:'darkorange', wordWrap:'break-word',fontSize:'0.9em'}}/>
                    </div>
                </>
            )
        } else {
            //collapsed
            return (
                <div style={{color:'darkorange',wordWrap:'break-word',fontSize:'0.9em'}}>
                    {result.max_bio_name}
                </div>
            )
        }
    }
    renderBioNetworkElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        let alarming_sensor_string:string = "N/A";
        const algorithm_name = (this.props.investigation as messages.Encounter.Encounter).algorithm_name;
        if(algorithm_name !== null){
            alarming_sensor_string = algorithm_name;
        }
        let alarming_sensor_title:string = "Algorithm";
        /*
        const alarming_sensors = (this.props.investigation as messages.Encounter.Encounter).alarming_sensors;
        if (alarming_sensors !== null && alarming_sensors.length > 0){
            alarming_sensors.forEach(sensor => {
                const make_model_string = sensor.make+' '+sensor.model;
                if(alarming_sensor_string.length > 0){
                    alarming_sensor_string += '\r\n'; //New line
                    alarming_sensor_title += 's'; //plural
                }
                alarming_sensor_string += make_model_string
            });
        } else {
            alarming_sensor_string = "N/A"
        }
        */
        const result = {alarming_sensors:alarming_sensor_string , max_bio_name: 'BIO'}
        if(expanded){
            return(
                <>
                    <div className="investigation-row">
                        <MetricsDisplay title={alarming_sensor_title} value={result.alarming_sensors} units={''} style={{width:'100%',whiteSpace:'pre-wrap'}} />
                    </div>
                </>
            )
        } else {
            //collapsed
            return (
                <div style={{color:'darkorange',wordWrap:'break-word',fontSize:'0.9em'}}>
                    {result.max_bio_name}
                </div>
            )
        }
    }
    renderChemNetworkElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        let alarming_sensor_string:string = "N/A";
        const algorithm_name = (this.props.investigation as messages.Encounter.Encounter).algorithm_name;
        if(algorithm_name !== null){
            alarming_sensor_string = algorithm_name;
        }
        let alarming_sensor_title:string = "Algorithm";
        let agent_id_title:string = "Chemical ID";
        /*
        const alarming_sensors = (this.props.investigation as messages.Encounter.Encounter).alarming_sensors;
        if (alarming_sensors !== null && alarming_sensors.length > 0){
            alarming_sensors.forEach(sensor => {
                const make_model_string = sensor.make+' '+sensor.model;
                if(alarming_sensor_string.length > 0){
                    alarming_sensor_string += '\r\n'; //New line
                    alarming_sensor_title += 's'; //plural
                }
                alarming_sensor_string += make_model_string
            });
        } else {
            alarming_sensor_string = "N/A"
        }
        */
        //const agent_id =  (this.props.investigation as messages.Encounter.Encounter);
        const result = this.findMaxChemicalThreat();
        //const result = {alarming_sensors:alarming_sensor_string , agent_id: 'CHEM'}
        if(expanded){
            return(
                <>
                    <div className="investigation-row">
                        <MetricsDisplay title={agent_id_title} value={result.max_chem_name} units={''} style={{width:'100%',whiteSpace:'pre-wrap'}} />
                    </div>
                </>
            )
        } else {
            //collapsed
            return (
                <div style={{color:'white',wordWrap:'break-word',fontSize:'0.9em'}}>
                    {result.max_chem_name}
                </div>
            )
        }
    }
    renderRadNetworkElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        if(expanded){
            var inv_isotopes =
                <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={false} hideConfidence={this.props.displayAsLanes}/>

            return (
                <>
                    {inv_isotopes}
                </>
            )
        } else {
            //collapsed
            return (
                <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={true} hideConfidence={this.props.displayAsLanes}/>
            )
        }
    }

    renameDeviceName = (deviceName:string)=>{
        if(API_ROOT.DeviceNameRemap){
            const nameMap = new Map<string, string>(
                API_ROOT.DeviceNameRemap.map((item:{DeviceName:string,DeviceDisplayName:string}) => [item.DeviceName, item.DeviceDisplayName])
            );
            return nameMap.get(deviceName) ?? deviceName;
        } else {
            return deviceName;
        }
    }

    render() {

        let display_as_nodes =  'alarming_sensors' in this.props.investigation;
        if('alarming_sensors' in this.props.investigation && this.props.investigation.alarming_sensors === null){
            if(this.props.investigation.type !== messages.Encounter.EncounterType.BIOSIGMA &&
                this.props.investigation.type !== messages.Encounter.EncounterType.CHEMSIGMA &&
               this.props.investigation.type !== messages.Encounter.EncounterType.RN_FUSION)
               display_as_nodes = false;
        }
        let display_node_name = true;
        //Expand/Collapse button
        var inv_expand_collapse;
        if (this.props.investigation.finalized) {
            var exp_collapse_string;
            if (!this.state.collapsed) {
                exp_collapse_string = '\u2212';
            } else {
                exp_collapse_string = '\u002B';
            }
            inv_expand_collapse =
                <div className="inv-exp-collapse-container" style={{ display: 'flex', cursor: 'pointer' }}
                        onClick={(event) => this.handleExpandCollapseClick(event)}>
                    <div className="inv-exp-collapse">{exp_collapse_string}</div>
                </div>
        }
        var timeAgo;
        if (this.props.investigation.finalized) {
            timeAgo = <TimeAgo lastEvent={new Date(this.props.investigation.end_time)} type={'inv'} />
        } else {
            timeAgo = <TimeAgo lastEvent={null} type={'inv'} />
        }

        //Investigation Title
        var title_string;
        if(this.props.isPrimary === undefined && this.props.displayAsLanes === undefined){
            // Default for mobile applications
            if (this.props.investigation.user_generated) {
                title_string = <div style={{ display: 'flex', flexDirection: 'row' }}><div className="inv-type-indicator">&#9733;</div>Manual Inv.</div>
            } else {
                title_string = 'Search Mode ';
                if('type' in this.props.investigation){
                    if(this.props.investigation.type !== undefined){
                        if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                            title_string =  <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center'}}>
                                                <div className="inv-type-indicator-img" style={{width:'30px'}}>
                                                    <img style={{background:'rbg(40,40,40)'}} className="inv-type-img" src={rad_alert_logo}/>
                                                </div>
                                                Rad. Alert
                                            </div>
                        } else if (this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                            title_string =  <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center'}}>
                                                <div className="inv-type-indicator-img" style={{width:'30px'}}>
                                                    <img className="inv-type-img" src={chem_alert_logo}/>
                                                </div>
                                                Chem. Alert
                                            </div>
                        } else if (this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                            title_string = <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center'}}>
                                                <div className="inv-type-indicator-img" style={{width:'30px'}}>
                                                    <img className="inv-type-img" src={bio_alert_logo}/>
                                                </div>
                                                Bio. Alert
                                            </div>
                        } else if (this.props.investigation.type === messages.Encounter.EncounterType.BIOSIGMA){
                            title_string = <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center',fontSize:'12px'}}>
                                                <div style={{ display: 'flex', flexDirection: 'column', width:'43px',height:'40px'}}>
                                                    <div className="inv-type-indicator-img">
                                                        <img className="inv-type-img" src={network_alert_logo}/>
                                                    </div>
                                                    <div className="inv-type-indicator-img" style={{position:'relative',top:'-16px',left:'10px'}}>
                                                        <img className="inv-type-img" src={bio_alert_logo}/>
                                                    </div>
                                                </div>
                                                Network Bio. Alert
                                            </div>
                        } else if (this.props.investigation.type === messages.Encounter.EncounterType.CHEMSIGMA){
                            title_string = <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center',fontSize:'12px'}}>
                                                <div style={{ display: 'flex', flexDirection: 'column', width:'43px',height:'40px'}}>
                                                    <div className="inv-type-indicator-img">
                                                        <img className="inv-type-img" src={network_alert_logo}/>
                                                    </div>
                                                    <div className="inv-type-indicator-img" style={{position:'relative',top:'-16px',left:'10px'}}>
                                                        <img className="inv-type-img" src={chem_alert_logo}/>
                                                    </div>
                                                </div>
                                                Network Chem. Alert
                                            </div>
                        } else if (this.props.investigation.type === messages.Encounter.EncounterType.RN_FUSION){
                            title_string = <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center',fontSize:'12px'}}>
                                                <div style={{ display: 'flex', flexDirection: 'column', width:'43px',height:'40px'}}>
                                                    <div className="inv-type-indicator-img">
                                                        <img className="inv-type-img" src={network_alert_logo}/>
                                                    </div>
                                                    <div className="inv-type-indicator-img" style={{position:'relative',top:'-16px',left:'10px'}}>
                                                        <img className="inv-type-img" src={rad_alert_logo}/>
                                                    </div>
                                                </div>
                                                Network Rad. Alert
                                            </div>
                        } else {
                            title_string = <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'', alignItems: 'center'}}>
                                                <div className="inv-type-indicator-img">
                                                    <img style={{background:''}} className="inv-type-img" src={alert_logo}/>
                                                </div>
                                                ALERT
                                            </div>
                        }
                    }
                }
            }
        } else if(!this.props.isPrimary){
            if(this.props.displayAsLanes){
                //SECONDARY
                title_string = 'SCAN ';
            }
        } else {
            if (this.props.investigation.user_generated) {
                title_string = <div style={{ display: 'flex', flexDirection: 'row' }}><div className="inv-type-indicator">&#9733;</div>Manual Inv.</div>
            } else {
                if(this.props.displayAsLanes){
                    //PRIMARY
                    title_string = 'ALERT ';
                } else {
                    title_string = 'Search Mode ';
                }
            }
        }
        const title =
            <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', flexGrow: 1, justifyContent: 'space-between', alignItems: 'center'}}>
                <label className="inv-type metric" style={{ fontSize: '1em' }}>{title_string}</label>
                <label className="inv-timeago metric" style={{ fontSize: '80%', color: '#707070' }}>
                    {timeAgo}
                </label>
            </div>
        var inv_title =
            <MetricsDisplay title={null} value={title} units={null} style={{ width: '100%', fontSize: '1em', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', minHeight: '30px' }} />


        var inv_body;
        var start = new Date(this.props.investigation.start_time);
        var end = new Date(this.props.investigation.end_time);
        let dominant_lane_string:string | undefined
        if (this.state.collapsed) {
            //Collapsed shows start time and summary
            let inv_type_elements;
            if('type' in this.props.investigation){
                if(display_as_nodes){
                    if(this.props.investigation.type === messages.Encounter.EncounterType.BIOSIGMA){
                        inv_type_elements = this.renderBioNetworkElements(false);
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEMSIGMA){
                        inv_type_elements = this.renderChemNetworkElements(false);
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.RN_FUSION){
                        inv_type_elements = this.renderRadNetworkElements(false);
                    } else {
                        inv_type_elements = this.renderNodeElements(false);
                    }
                } else {
                    if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                        inv_type_elements= this.renderRadElements(false);
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                        inv_type_elements= this.renderChemElements(false);
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                        inv_type_elements= this.renderBioElements(false);
                    }
                }
            } else {
                //Default to Rad based display if investigation
                //Max Gamma and Dose Rate
                inv_type_elements= this.renderRadElements(false)
            }
            /*
            var  summary =
                <div className="investigation-column">
                    {start.toLocaleDateString() + " " + start.toLocaleTimeString()}
                    <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={true} hideConfidence={this.props.displayAsLanes}/>
                </div>
            */
            var  summary =
                <div className="investigation-column">
                    {start.toLocaleDateString() + " " + start.toLocaleTimeString()}
                    {inv_type_elements}
                </div>

            var dismiss_hidden;
            if (this.props.investigation.finalized) {
                dismiss_hidden = <div className="inv-delete-all-hidden" style={{display:'none'}} onClick={this.handleDismissConfirmClick}/>
            }

            inv_body =
                <>
                    <div className="investigation-column">
                        <div className="investigation-row">
                            <MetricsDisplay title={null} value={summary} units={null} style={{ width: '100%' }} />
                        </div>
                    </div>
                    {/*INVISIBLE DIVS USED FOR EXPERT SETTINGS */}
                    <div className={'expertSettings'} style={{display:'none'}}>
                        {dismiss_hidden}
                        <BD21ShareButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            queryDatastream={this.props.investigationInterface.queryDatastream}
                            style={{width: '230px' }} />
                    </div>
                </>

        } else {
            //Expanded
            //Investigation start and end times
            const inv_times =
                <div className="investigation-row">
                    <MetricsDisplay title={'Start Time'} value={start.toLocaleString()} units={null}
                        style={{ minHeight: '3em' }} />
                    <MetricsDisplay title={'End Time'} value={end.toLocaleString()} units={null}
                        style={{ minHeight: '3em' }} />
                </div>



            let inv_locations;
            if(display_as_nodes){
                //Display as nodes for BD21-copy
                //Vehicle Location and source location
                let node_loc = "N/A";
                if (this.props.investigation.vehicle_location !== null) {
                    node_loc = this.props.investigation.vehicle_location.latitude.toFixed(6) + ", " +
                        this.props.investigation.vehicle_location.longitude.toFixed(6);
                }

                //Get node name from encounter header (passed through message)
                let node_name = "N/A";
                if((this.props.investigation as messages.Encounter.Encounter).node_name !== undefined &&
                   (this.props.investigation as messages.Encounter.Encounter).node_name !== null){
                    node_name = (this.props.investigation as messages.Encounter.Encounter).node_name;
                    node_name = NodeHealth.remapDeviceName(node_name)
                    node_name= node_name.replace(/_/g," ");
                }
                if('type' in this.props.investigation && this.props.investigation.type === messages.Encounter.EncounterType.BIOSIGMA){
                    //Network Level alert
                    let glrt_string;
                    let glrt_display_title;
                    if(this.props.investigation.finalized){
                        glrt_string = '';
                        glrt_display_title = 'GLRT (max)'
                    } else {
                        if(this.props.investigation.current_glrt !== null){
                            if(Math.abs(this.props.investigation.current_glrt) < 10){
                                glrt_string = this.props.investigation.current_glrt.toFixed(2);
                            } else if(Math.abs(this.props.investigation.current_glrt) < 100){
                                glrt_string = this.props.investigation.current_glrt.toFixed(1);
                            } else {
                                glrt_string = this.props.investigation.current_glrt.toFixed(0);
                            }
                        } else {
                            glrt_string = 'N/A'
                        }
                        glrt_string = glrt_string + ' | ';
                        glrt_display_title = 'GLRT (cur | max)'
                    }
                    if(this.props.investigation.max_glrt !== null){
                        if(Math.abs(this.props.investigation.current_glrt) < 10){
                            glrt_string += this.props.investigation.max_glrt.toFixed(2);
                        } else if(Math.abs(this.props.investigation.current_glrt) < 100){
                            glrt_string += this.props.investigation.max_glrt.toFixed(1);
                        } else {
                            glrt_string += this.props.investigation.max_glrt.toFixed(0);
                        }
                    } else {
                        glrt_string += 'N/A'
                    }
                    let est_rel_loc = "N/A";
                    if (this.props.investigation.source_location !== null) {
                        est_rel_loc = this.props.investigation.source_location.latitude.toFixed(6) + ", " +
                            this.props.investigation.source_location.longitude.toFixed(6);
                    }
                    inv_locations =
                        <div className="investigation-row">
                            <MetricsDisplay title={'Est. Rel. Location'} value={est_rel_loc} units={null} style={{ minHeight: '3em' }} />
                            <MetricsDisplay title={glrt_display_title} value={glrt_string} units={null} style={{ minHeight: '3em' }} />
                        </div>
                } else if('type' in this.props.investigation && this.props.investigation.type === messages.Encounter.EncounterType.CHEMSIGMA){
                    //Network Level alert
                    let glrt_string;
                    let glrt_display_title;
                    if(this.props.investigation.finalized){
                        glrt_string = '';
                        glrt_display_title = 'GLRT (max)'
                    } else {
                        if(this.props.investigation.current_glrt !== null){
                            if(Math.abs(this.props.investigation.current_glrt) < 10){
                                glrt_string = this.props.investigation.current_glrt.toFixed(2);
                            } else if(Math.abs(this.props.investigation.current_glrt) < 100){
                                glrt_string = this.props.investigation.current_glrt.toFixed(1);
                            } else {
                                glrt_string = this.props.investigation.current_glrt.toFixed(0);
                            }
                        } else {
                            glrt_string = 'N/A'
                        }
                        glrt_string = glrt_string + ' | ';
                        glrt_display_title = 'GLRT (cur | max)'
                    }
                    if(this.props.investigation.max_glrt !== null){
                        if(Math.abs(this.props.investigation.current_glrt) < 10){
                            glrt_string += this.props.investigation.max_glrt.toFixed(2);
                        } else if(Math.abs(this.props.investigation.current_glrt) < 100){
                            glrt_string += this.props.investigation.max_glrt.toFixed(1);
                        } else {
                            glrt_string += this.props.investigation.max_glrt.toFixed(0);
                        }
                    } else {
                        glrt_string += 'N/A'
                    }
                    let est_rel_loc = "N/A";
                    if (this.props.investigation.source_location !== null) {
                        est_rel_loc = this.props.investigation.source_location.latitude.toFixed(6) + ", " +
                            this.props.investigation.source_location.longitude.toFixed(6);
                    }
                    inv_locations =
                        <div className="investigation-row">
                            <MetricsDisplay title={'Est. Rel. Location'} value={est_rel_loc} units={null} style={{ minHeight: '3em' }} />
                            <MetricsDisplay title={glrt_display_title} value={glrt_string} units={null} style={{ minHeight: '3em' }} />
                        </div>
                } else if('type' in this.props.investigation && this.props.investigation.type === messages.Encounter.EncounterType.RN_FUSION){
                    let est_rel_loc = "N/A";
                    if (this.props.investigation.source_location !== null) {
                        est_rel_loc = this.props.investigation.source_location.latitude.toFixed(6) + ", " +
                            this.props.investigation.source_location.longitude.toFixed(6);
                    }
                    let est_src_activity = "N/A";
                    if (this.props.investigation.isotopes !== null){
                        if (this.props.investigation.isotopes.length > 0) {
                            const max_activity = this.props.investigation.isotopes.reduce((prev:messages.Rad.IsotopeResult, current:messages.Rad.IsotopeResult) =>
                                (prev && prev.estimated_activity > current.estimated_activity) ? prev : current);
                            if(max_activity !== undefined)
                                est_src_activity = (max_activity.estimated_activity).toFixed(1);
                        }
                    }
                    inv_locations =
                        <div className="investigation-row">
                            <MetricsDisplay title={'Est. Src. Location'} value={est_rel_loc} units={null} style={{ minHeight: '3em' }} />
                            <MetricsDisplay title={'Effective Activity'} value={'~'+est_src_activity} units={'mCi'} style={{ minHeight: '3em' }} />
                        </div>
                } else {
                    //Node level alert
                    inv_locations =
                        <div className="investigation-row">
                            <MetricsDisplay title={'Location'} value={node_loc} units={null} style={{ minHeight: '3em' }} />
                            <MetricsDisplay title={'Node Name'} value={node_name} units={null} style={{ minHeight: '3em' }} />
                        </div>
                }

            } else {
                if(this.props.displayAsLanes){
                    //Lane display
                    var lane_loc = "N/A";
                    if(this.props.isPrimary){
                        if(this.props.investigation.source_lane !== undefined){
                            if(this.props.investigation.source_lane !== null){
                                if(this.props.laneDisplayInterface?.laneNumberAndLabel){
                                    this.props.laneDisplayInterface.laneNumberAndLabel.forEach((lane=>{
                                        if(lane.laneNumber === this.props.investigation.source_lane)
                                            lane_loc = lane.laneLabel.toString();
                                    }));
                                } else {
                                    lane_loc = (this.props.investigation.source_lane+1).toFixed(0);
                                }
                                dominant_lane_string = lane_loc;
                            }
                        }

                        //Display alternative attribution lane number
                        const alt_lane = AltAttributionUtil.getAltAttrSourceLaneLabel(this.props.investigation,this.props.laneDisplayInterface);
                        if(alt_lane){
                            lane_loc = lane_loc+', '+alt_lane;
                        }

                    } else {
                        //SECONDARY
                        if(this.props.laneDisplayInterface?.laneNumberAndLabel){
                            this.props.laneDisplayInterface.laneNumberAndLabel.forEach((lane)=>{
                                    lane_loc = lane.laneLabel.toString();;
                            });
                        }
                    }
                    inv_locations =
                        <div className="investigation-row">
                            <MetricsDisplay title={'Lane'} value={lane_loc} units={null} style={{width:'100%'}} />
                        </div>
                } else {
                    //Vehicle Location and source location
                    var veh_loc = "N/A";
                    if (this.props.investigation.vehicle_location !== null) {
                        veh_loc = this.props.investigation.vehicle_location.latitude.toFixed(6) + ", " +
                            this.props.investigation.vehicle_location.longitude.toFixed(6);
                    }
                    let src_loc_title = "Source Location";
                    var src_loc = "N/A";
                    if(this.props.showSourceLocationAsDirection){
                        if(this.props.useSourceHeadingAndSourceLanePositionForDirection){
                            if(this.props.investigation.relative_bearing_to_source !== null){
                                if(this.props.investigation.relative_bearing_to_source === 90){
                                    src_loc = "Right Side";
                                }
                                if(this.props.investigation.relative_bearing_to_source === 270){
                                    src_loc = "Left Side";
                                }
                            } else if (this.props.investigation.source_lane_position !== null){
                                if(this.props.investigation.source_lane_position === 0){
                                    src_loc = "Bottom";
                                }
                                if(this.props.investigation.source_lane_position === 1){
                                    src_loc = "Top";
                                }
                            }
                        } else {
                            if(this.props.investigation.source_lane !== undefined){
                                if(this.props.investigation.source_lane !== null){
                                    if(this.props.investigation.source_lane === 0){
                                        src_loc = "Left Side";
                                    }
                                    if(this.props.investigation.source_lane === 1){
                                        src_loc = "Right Side";
                                    }
                                }
                            }
                        }
                    } else if (this.props.showNodeLocationInsteadofSourceLocation){
                        let node_name = "N/A";
                        if((this.props.investigation as messages.Encounter.Encounter).node_name !== undefined &&
                           (this.props.investigation as messages.Encounter.Encounter).node_name !== null){
                            node_name = (this.props.investigation as messages.Encounter.Encounter).node_name;
                            node_name = NodeHealth.remapDeviceName(node_name);
                            node_name = this.renameDeviceName(node_name);
                            node_name= node_name.replace(/_/g," ");
                            src_loc = node_name;
                        }
                        src_loc_title = "Node Name"
                    } else {
                        if('source_location' in this.props.investigation){
                            if (this.props.investigation.source_location !== null) {
                                src_loc = this.props.investigation.source_location.latitude.toFixed(6) + ", " +
                                    this.props.investigation.source_location.longitude.toFixed(6);
                            }
                        } else if ('isotope_location' in this.props.investigation) {
                            if (this.props.investigation.isotope_location !== null) {
                                src_loc = this.props.investigation.isotope_location.latitude.toFixed(6) + ", " +
                                    this.props.investigation.isotope_location.longitude.toFixed(6);
                            }
                        }
                    }
                    inv_locations =
                        <div className="investigation-row">
                            <MetricsDisplay title={'Node Location'} value={veh_loc} units={null} style={{ minHeight: '3em' }} />
                            <MetricsDisplay title={src_loc_title} value={src_loc} units={null} style={{ minHeight: '3em' }} />
                        </div>
                }
            } // Not as nodes

            let inv_type_elements;
            if('type' in this.props.investigation){
                if(display_as_nodes){
                    if(this.props.investigation.type === messages.Encounter.EncounterType.BIOSIGMA){
                        inv_type_elements = this.renderBioNetworkElements();
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEMSIGMA){
                        inv_type_elements = this.renderChemNetworkElements();
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.RN_FUSION){
                        inv_type_elements = this.renderRadNetworkElements();
                    } else {
                        inv_type_elements = this.renderNodeElements();
                    }
                } else {
                    if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                        inv_type_elements= this.renderRadElements();
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                        inv_type_elements= this.renderChemElements();
                    } else if(this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                        inv_type_elements= this.renderBioElements();
                    }
                }
            } else {
                //Default to Rad based display if investigation
                //Max Gamma and Dose Rate
                var gamma_rate = "N/A";
                if (this.props.investigation.max_count_rate !== null) {
                    gamma_rate = this.props.investigation.max_count_rate.toFixed(1)
                }
                var dose_rate = "N/A";
                if (this.props.investigation.max_count_rate !== null) {
                    dose_rate = this.props.investigation.max_dose_rate.toFixed(1)
                }
                const inv_rates =
                    <div className="investigation-row">
                        <MetricsDisplay title={'Peak Gamma Rate'} value={gamma_rate} units={'cps'} style={undefined} />
                        <MetricsDisplay title={'Peak Dose Rate'} value={dose_rate} units={'\u00B5R/hr'} style={undefined} />
                    </div>

                const inv_isotopes =
                    <IsotopeDisplay isotopes={this.props.investigation.isotopes}
                                    laneLabel={dominant_lane_string}
                                    altIsotopes={AltAttributionUtil.getAltAttrSourceIsotopes(this.props.investigation)}
                                    altLaneLabel={AltAttributionUtil.getAltAttrSourceLaneLabel(this.props.investigation,this.props.laneDisplayInterface)}
                                    summary={false} hideConfidence={this.props.displayAsLanes}/>
                inv_type_elements =
                    <>
                        {inv_rates}
                        {inv_isotopes}
                    </>
            }

            //Buttons
            var dismiss_button;
            if (this.props.investigation.finalized) {
                dismiss_button =
                    <>
                        <div className="inv-dismiss-container inv-menu-item" style={{ display: 'flex', cursor: 'pointer' }}
                                onClick={(event) => this.handleDismissClick(event)}>
                            <img src={recycle_logo} alt="Delete" className="inv-delete inv-menu-button"></img>
                        </div>
                        <div className="inv-delete-all-hidden" style={{display:'none'}}
                                onClick={(event) => this.handleDismissConfirmClick(event)}/>
                    </>
            } else {
                dismiss_button =
                    <div className="inv-dismiss-container-spacer">
                        <img src={recycle_logo} alt="Delete" style={{ opacity: '0.1' }}></img>
                    </div>
            }

            var dismiss_dialog;
            if (this.state.dismiss_dialog_show) {
                dismiss_dialog =
                    <div className="inv-dismiss-dialog-container inv-menu-item"
                            style={{ display: 'flex', width: '100%', height: '40px', opacity: '1.0' }}>
                        <div className="inv-dismiss-undo-container inv-menu-item">
                            <img src={undo_logo} alt="Cancel Delete" className="inv-delete-undo inv-menu-button"
                                style={{ cursor: 'pointer' }}
                                onClick={(event) => this.handleDismissCancelClick(event)}></img>
                        </div>
                        <div className="inv-dismiss-confirm-container inv-menu-item">
                            <img src={recycle_logo} alt="Confirm Delete" className="inv-delete-confirm inv-menu-button"
                                style={{ cursor: 'pointer' }}
                                onClick={(event) => this.handleDismissConfirmClick(event)}></img>
                        </div>
                    </div>
            }

            let shareAndSnoozeIsopeButton;
            if(this.props.showSnoozeIsotopeButton){
                shareAndSnoozeIsopeButton =
                    <>
                        <BD21ShareButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            queryDatastream={this.props.investigationInterface.queryDatastream}
                            style={{ width: '250px', left:'33px'}} />
                        <SnoozeIsotopeButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            style={{ width: '250px', left:'-33px'}}
                            authenticationInterface={this.props.authenticationInterface}/>
                    </>
            } else {
                shareAndSnoozeIsopeButton =
                        <BD21ShareButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            queryDatastream={this.props.investigationInterface.queryDatastream}
                            style={{ width: '250px' }} />
            }

            let allowReplay = false;
            let spawnCloudUi = false;
            if('type' in this.props.investigation){
                if(this.props.investigation.type === messages.Encounter.EncounterType.BIO ||
                    this.props.investigation.type === messages.Encounter.EncounterType.BIOSIGMA ||
                    this.props.investigation.type === messages.Encounter.EncounterType.CHEMSIGMA) {
                        allowReplay = true;
                } else if (this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                    if(HasCloudUI(this.props.investigation.node_name)){
                        allowReplay = true;
                        spawnCloudUi = true;
                    } else if (IsAllowReplay(this.props.investigation.node_name)){
                        allowReplay = true;
                    }
                }
            }
            let allowReplayStyle:React.CSSProperties = {};
            if(!allowReplay){
                allowReplayStyle = {opacity:'0.3',pointerEvents:'none'};
            }
            let buttons =
                <div className="investigation-row" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop: '5px' }}>
                    <div className="inv-replay-container-spacer" style={allowReplayStyle}>
                        <img src={spawnCloudUi ? open_in_new_logo : this.props.replaying? replay_white_logo: replay_logo} alt="Toggle Replay" style={{ cursor: 'pointer' }}
                            onClick={() => this.handleReplayClick()} />
                    </div>
                    {shareAndSnoozeIsopeButton}
                    {dismiss_button}
                </div>

            inv_body =
                <div className="investigation-column">
                    {inv_times}
                    {inv_locations}
                    {inv_type_elements}
                    {buttons}
                    {dismiss_dialog}
                </div>
        }

        var investigationCardClasses = 'InvestigationCard';
        if (!this.props.investigation.finalized) {
            investigationCardClasses += ' active';
        }
        if (this.state.dismissed) {
            investigationCardClasses += ' dismissed';
        }
        if (this.props.selected) {
            investigationCardClasses += ' selected';
        }
        if (this.props.replaying) {
            investigationCardClasses += ' replaying';
        }
        if (!this.state.acknowledged) {
            investigationCardClasses += ' acknowledge';
        }

        return (
            <div className={investigationCardClasses} onClick={(event) => this.handleSelectClick(event)}
                    ref={this.card_element}>
                <div ref={this.card_scroll_to_element} style={{ position: 'relative', top: '-10px' }} />
                <div className="investigation-column">
                    <div className="investigation-row">
                        {inv_title}
                        {inv_expand_collapse}
                    </div>
                    {inv_body}
                </div>
            </div>
        )
    }
}

const MemoizedInvestigationCard = React.memo(InvestigationCard,cardsAreEqual);

function cardsAreEqual(prevProps:InvestigationCardProps,nextProps:InvestigationCardProps){

        const flag = prevProps.investigation === nextProps.investigation &&
                    prevProps.selected === nextProps.selected &&
                    prevProps.replaying === nextProps.replaying &&
                    prevProps.investigationsNotAcknowledged?.length === nextProps.investigationsNotAcknowledged?.length &&
                    prevProps.investigationsCollapsed?.length === nextProps.investigationsCollapsed?.length &&
                    prevProps.investigation.finalized === nextProps.investigation.finalized
                    //prevProps.useDoseRateSIUnit === nextProps.useDoseRateSIUnit &&
                    //prevProps.coralResults === nextProps.coralResults &&
                    //prevProps.language === nextProps.language

        //if(prevProps.coralResults !== nextProps.coralResults){
        //    console.log('coral results different!')
        //}
        return (flag);
}

//******************************************************************************
interface InvestigationDisplayProps {
    investigations: Investigation[],
    currentPCSResult: PCSResult | null,
    currentNeutronResult: NeutronResult | null,

    selectedInvestigation?: Investigation,
    replayInvestigation?: Investigation,
    investigationsNotAcknowledged?: Investigation[],
    investigationsCollapsed?: Investigation[],
    investigationInterface: InvestigationInterface,
    displayAsLanes?: boolean,
    isPrimary?: boolean,
    laneDisplayInterface?: LaneDisplayInterface,
    numInvInitialLoad?: number,
    numInvLoadIncrement?: number,
    showAudioControl?: boolean,
    showSourceLocationAsDirection?: boolean,
    showNodeLocationInsteadofSourceLocation?: boolean,
    useSourceHeadingAndSourceLanePositionForDirection?: boolean,
    invTypeToShow?: InvTypeToShow|null,
    useTTSVoice?: string,
    showSnoozeIsotopeButton?: boolean,
    authenticationInterface?: AuthenticationInterface,
    cloudUiDisplayInterface?: CloudUiDisplayInterface,
    //config?: Config,
}

interface InvestigationDisplayState {
    maxNumToDisplay: number,
}
export class BioInvestigationEncounterDisplay extends React.Component<InvestigationDisplayProps, InvestigationDisplayState> {
    display_element: React.RefObject<HTMLDivElement>;
    inv_load_init: number = this.props.numInvInitialLoad?  this.props.numInvInitialLoad : 50;
    inv_load_increment: number = this.props.numInvLoadIncrement?  this.props.numInvLoadIncrement : 50;
    displayed_to_time: number;
    latest_inv_time: number;
    //timeoutTimer: NodeJS.Timeout | null;

    constructor(props: InvestigationDisplayProps) {
        super(props)
        this.state={
            maxNumToDisplay: this.inv_load_init,
        }
        this.latest_inv_time = new Date().getTime();
        this.displayed_to_time = new Date().getTime();
        this.display_element = React.createRef<HTMLDivElement>();
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
        this.handleInvTypeSelectClick = this.handleInvTypeSelectClick.bind(this);
        //this.timeoutTimer = null;
    }

    componentDidUpdate(prevProps: InvestigationDisplayProps) {
        if (this.display_element.current !== null) {
            if(this.props.investigations.length > prevProps.investigations.length) {
                if(this.props.replayInvestigation === undefined) {
                    //Scroll to top only if not in replay mode
                    if(this.props.investigations[0].start_time > this.latest_inv_time){
                        const num_inv_diff = this.props.investigations.length - prevProps.investigations.length;
                        //New Investigation was added
                        const list = this.display_element.current;
                        //list.scrollTop = 0;
                        list.scrollTo({
                            top:0,
                            behavior:'smooth'
                        })
                        this.latest_inv_time = this.props.investigations[0].start_time;
                        this.setState(state=>({
                            maxNumToDisplay: state.maxNumToDisplay + num_inv_diff
                        }));
                    }
                }
            } else if(this.props.replayInvestigation === undefined && prevProps.replayInvestigation !== undefined){
                //Scroll back to unacknowledged alerts upon exiting from replay
                if(this.props.investigationsNotAcknowledged){
                    if(this.props.investigationsNotAcknowledged.length > 0){
                        const list = this.display_element.current;
                        list.scrollTo({
                            top:0,
                            behavior:'smooth'
                        })
                    }
                }
            }
            //if(this.props.investigationsCollapsed?.length !== prevProps.investigationsCollapsed?.length){
            //    console.log("collapsed changed")
            //    this.render();
            //}
        }
    }

    componentDidMount(){
        /*
        this.timeoutTimer = setTimeout(()=>{
            this.render();
            console.log('periodic Alert Display refresh')
        },60000);
        */
    }
    componentWillUnmount() {
        /*
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        */
    }
    handleShowMoreClick(){
        //console.log('Load More Clicked');
        this.setState(state=>({
            maxNumToDisplay: state.maxNumToDisplay + this.inv_load_increment
        }));
    }

    handleInvTypeSelectClick(){
        if(this.props.invTypeToShow !== undefined){
            if(this.props.investigationInterface !== undefined && this.props.investigationInterface.setInvTypeToShow !== undefined){
                if(this.props.invTypeToShow === null){
                    this.props.investigationInterface.setInvTypeToShow([messages.Encounter.EncounterType.BIOSIGMA,messages.Encounter.EncounterType.RN_FUSION]);
                } else {
                    this.props.investigationInterface.setInvTypeToShow(null);
                }
            }
        }
    }


    render() {
        let investigations = this.props.investigations;
        let investigationToDisplay = investigations.slice(0,this.state.maxNumToDisplay)

        const cards = investigationToDisplay.map((inv) =>
            <MemoizedInvestigationCard key={uuidToString(inv.id)}
                investigation={inv}
                selected={inv.id === this.props.selectedInvestigation?.id}
                replaying={inv.id === this.props.replayInvestigation?.id}
                investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                investigationsCollapsed={this.props.investigationsCollapsed}
                investigationInterface={this.props.investigationInterface}
                displayAsLanes={this.props.displayAsLanes}
                isPrimary={this.props.isPrimary}
                showSourceLocationAsDirection={this.props.showSourceLocationAsDirection}
                showNodeLocationInsteadofSourceLocation={this.props.showNodeLocationInsteadofSourceLocation}
                useSourceHeadingAndSourceLanePositionForDirection={this.props.useSourceHeadingAndSourceLanePositionForDirection}
                laneDisplayInterface={this.props.laneDisplayInterface}
                showSnoozeIsotopeButton={this.props.showSnoozeIsotopeButton}
                authenticationInterface={this.props.authenticationInterface}
                cloudUiDisplayInterface={this.props.cloudUiDisplayInterface}
                />
        );

        const exitReplay = this.props.replayInvestigation?
            <div id="ExitReplay" className="round-button" onClick={() => this.props.investigationInterface.unreplay()}>
                Exit Replay
            </div> : <></>;

        const invLeftToDisplay = investigations.length-investigationToDisplay.length;
        const invShowString = (invLeftToDisplay > this.inv_load_increment) ? this.inv_load_increment.toFixed(0)+' more' : 'All'
        const loadMore = (invLeftToDisplay > 0) ?
            <div id="ShowMore" className="round-button" onClick={this.handleShowMoreClick}>
                Show {invShowString} ({invLeftToDisplay} left)
            </div> : <></>;
        let hideAudioControl = true;
        let isSecondary:boolean|undefined;
        if(this.props.isPrimary === undefined){
            isSecondary = undefined;
        } else {
            isSecondary = !this.props.isPrimary;
        }
        if(this.props.showAudioControl === true){
            hideAudioControl = false;
        }

        /*
        let invTypeToShowImg;
        if(this.props.invTypeToShow === null){
            invTypeToShowImg =
                <>
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={network_alert_logo} title={'Network Alert'}/>
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={rad_alert_logo} title={'Rad Node Alert'}/>
                </>
        } else if (this.props.invTypeToShow?.includes(messages.Encounter.EncounterType.RAD)){
            invTypeToShowImg =
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={rad_alert_logo} title={'Rad Node Alert'}/>
        } else if (this.props.invTypeToShow?.includes(messages.Encounter.EncounterType.BIOSIGMA)){
            invTypeToShowImg =
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={network_alert_logo} title={'Network Alert'}/>
        } else if (this.props.invTypeToShow?.includes(messages.Encounter.EncounterType.RN_FUSION)){
            invTypeToShowImg =
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={network_alert_logo} title={'Network Alert'}/>
        }


        const alertSwitch = (invTypeToShowImg !== undefined) ?
            <div id="AlertSwitch" className="round-button" style={{margin:'10px',marginRight:'5px',marginTop:'0px'}}onClick={this.handleInvTypeSelectClick}>
                Alerting on: {invTypeToShowImg}
            </div> : <></>;
        */
        let audioAlertDisplay;
        audioAlertDisplay =<div> </div>

        audioAlertDisplay =
            <MultiNodeAudioAlertDisplay investigations={investigations}
                investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                currentPCSResult={this.props.currentPCSResult}
                currentNeutronResult={this.props.currentNeutronResult}
                hidden={hideAudioControl}
                isSecondary={isSecondary}
                convertLaneToDirection={this.props.showSourceLocationAsDirection}
                useSourceHeadingAndSourceLanePositionForDirection={this.props.useSourceHeadingAndSourceLanePositionForDirection}
                laneToAlarm={this.props.laneDisplayInterface?.laneToDisplay}
                laneDisplayInterface={this.props.laneDisplayInterface}
                useTTSVoice={this.props.useTTSVoice}
                disableMuteForOne={true}
                />

        return (
            <>
            <div className="InvestigationDisplay" >
                <div className="header" style={{minHeight:'28px'}}>
                    <span>Alerts</span>
                    {exitReplay}
                    {audioAlertDisplay}
                </div>
                <div className={`body ${this.props.replayInvestigation ? 'replay' : ''}`} ref={this.display_element}>
                    {cards}
                    {loadMore}
                </div>
            </div>
            </>
        )
    }
}

export default BioInvestigationEncounterDisplay

export class AltAttributionUtil {

    static getAltAttrSourceLaneLabel(inv:Investigation, laneDisplayInterface?:LaneDisplayInterface) {
        let lane_string:string|undefined;
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                    inv.alternative_attributions.forEach((attr=>{
                        if(attr.source_lane !== undefined && attr.source_lane !== null){
                                if(laneDisplayInterface?.laneNumberAndLabel){
                                    laneDisplayInterface.laneNumberAndLabel.forEach((lane=>{
                                        if(lane.laneNumber === attr.source_lane)
                                            lane_string = lane.laneLabel.toString();
                                    }));
                                } else {
                                    lane_string = (attr.source_lane+1).toFixed(0);
                                }
                        }
                    }));
            }
        }
        return lane_string;
    }

    static getAltAttrSourceIsotopes(inv:Investigation) {
        let isotopes:messages.Rad.IsotopeResult[]|undefined;
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                    inv.alternative_attributions.forEach((attr=>{
                        isotopes = attr.isotopes;
                    }));
            }
        }
        return isotopes;
    }

    static isAltAttrInThisLane(inv:Investigation, lanePosition?: number|undefined) {
        let result = false;
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null){
                inv.alternative_attributions.forEach((attr=>{
                    if(attr.source_lane !== undefined && attr.source_lane !== null){
                        if(attr.source_lane === lanePosition){
                            if(attr.isotopes.length > 0)
                                result = true;
                        } else if (lanePosition===undefined){
                            //Lane position undefined means it is in multilane display
                            if(attr.isotopes.length > 0)
                                result = true;
                        }
                    }
                }));
            }
        }
        return result;
    }

    static getAltAttrIsotopeName(inv:Investigation) {
        let name="";
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                let attr = inv.alternative_attributions[0];
                if(attr.isotopes !== undefined && attr.isotopes !== null){
                    if(attr.isotopes.length > 0)
                        name = attr.isotopes[0].name;
                }
            }
        }
        return name;
    }

    static getAltAttrIsotopeCategory(inv:Investigation) {
        let category="";
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                let attr = inv.alternative_attributions[0];
                if(attr.isotopes !== undefined && attr.isotopes !== null){
                    if(attr.isotopes.length > 0)
                        category = attr.isotopes[0].category;
                }
            }
        }
        return category;
    }

    static getAltAttrImageId(inv:Investigation | undefined) {
        let image_id = null;
        if(inv === undefined)
            return image_id;
            if('type' in inv){
                //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                let attr = inv.alternative_attributions[0];
                if(attr.image !== undefined && attr.image !== null){
                    image_id = attr.image;
                }
            }
        }
        return image_id;
    }


}
